import { Box, Typography, Button, List, ListItem, Radio, RadioGroup, FormControl, FormLabel, IconButton, Input } from "@mui/joy";
import { useState } from "react";
import { IForgotPwdFormData, IForgotPwdPayload } from "../../utils/types";
import { TextInput } from "../../utils/input";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  useForgotPasswordMutation,
  useGetVendorDetailswithCodeMutation,
  useGetVerifyVendorMutation,
  useSendOtpMutation,
  useVerifyOTPMutation,
} from "../../services/auth/authApiSlice";
import Loading from "../../components/Common/Loading";
import { useNavigate } from "react-router-dom";
import ForgotPasswordDetailsCard from "./ForgotPasswordDetailsCard";

interface IExtendedForgotPwdFormData extends IForgotPwdFormData {
  userType: "vendor" | "employee";
  phone?: string;
  name?: string;
  otp?: string;
}

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const baseformData: IExtendedForgotPwdFormData = {
    vendorCode: "",
    password: "",
    repeatPassword: "",
    userType: "vendor",
    phone: "",
    name: "",
  };

  const [selectedVendor, setSelectedVendor] = useState(null);

  const [isVerify, setIsVerify] = useState(false);
  const [formData, setFormData] = useState<IExtendedForgotPwdFormData>(baseformData);
  const [showPasswordValidation, setShowPasswordValidation] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState<boolean>(false);
  const [vendorNotFound, setVenderNotFound] = useState<any>(false);
  const [verifyData, setVerifyData] = useState<any>(null);
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [sendOtp, { isLoading: sendOtpLoading }] = useSendOtpMutation();
  const [verifyOTP, { isLoading: verifyOtpLoading }] = useVerifyOTPMutation();

  const [forgotPasswordSubmit, { isLoading }] = useForgotPasswordMutation();
  const [getVerifyVendor, { isLoading: isLoadingVenderChecking }] = useGetVerifyVendorMutation();
  const [getVendorDetails, { isLoading: isVendorDetailsLoading }] = useGetVendorDetailswithCodeMutation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if ('otp' === name && value.length > 6) {
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "password") {
      setShowPasswordValidation(value.length > 0);
    }
  };

  const handleUserTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsVerify(false);
    setIsOtpSent(false);
    setShowPasswordValidation(false);
    setShowPassword(false);
    setVenderNotFound(false);
    setVerifyData(null);
    setIsOtpSent(false);
    setIsOtpVerified(false);

    setFormData((prev) => ({
      vendorCode: "",
      password: "",
      repeatPassword: "",
      phone: "",
      name: "",
      userType: event.target.value as "vendor" | "employee",
    }));
  };

  const validatePassword = (password: string) => {
    return {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };

  const handleForgotPasswordClick = async () => {
    try {
      const payload: IForgotPwdPayload = {
        login_type: formData?.userType,
        vendor_id: formData?.vendorCode,
        password: formData?.password,
      };
      const result = await forgotPasswordSubmit(payload).unwrap();
      if (result?.success) {
        toast.success(result?.message);
        navigate("/login", { replace: true });
      } else {
        toast.error(result?.message);
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const handleVerifyVendorId = async () => {
    let vendor_id = "00" + formData.vendorCode.replace(/^0+/, "");
    try {
      const result: any = await getVendorDetails({ vendor_code: vendor_id }).unwrap();
      setIsVerify(false);
      if (result?.message === "Vendor not Found") {
        setVenderNotFound(true);
        setFormData((prev) => ({
          ...prev,
          phone: "xxxxx",
          name: "",
        }));
      } else {
        const vendorData: any = { ...result?.vendor_data };
        var vData: any = {
          phone: vendorData.Mobile,
          name: vendorData.VendorName,
          emailId: vendorData.Email,
          lifnr: vendorData.VendorID,
        }
        setVerifyData([{ ...vData }]);
        setIsVerify(true);

        setFormData((prev) => ({
          ...prev,
          phone: vendorData.Mobile,
          name: vendorData.VendorName,
          emailId: vendorData.Email,
          lifnr: vendorData.VendorID,
        }));
        setIsOtpSent(false);
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const handleInputPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value) && value.length < 11) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleSendOtp = async () => {
    try {
      const response = await sendOtp({ mobile: formData?.phone, type: 'reset' }).unwrap();

      if (response?.success) {
        toast.success(response?.message);
        setIsOtpSent(true);
      } else {
        toast.error(`Error Sending OTP: ${response?.message}`);
      }
      // Call OTP send API here
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };
  const handleVerifyOtp = async () => {
    try {
      const response: any = await verifyOTP({ otp: formData?.otp, phone_number: formData.phone }).unwrap();
      if (response?.success) {
        toast.success(response?.message);
        setIsOtpVerified(true);
        setVerifyData([...response?.vendor_data]);
      } else {
        toast.error(`Error Verifying OTP: ${response?.message}`);
      }
    } catch (err) {
      console.log("err", err);
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const formControlSx = { width: "100%" };
  const passwordValidation = validatePassword(formData.password);
  const isPasswordValid = Object.values(passwordValidation).every(Boolean);
  const isPasswordMatched = formData.password === formData.repeatPassword;
  const otpFormControlSx = {
    width: "100%",
    ...(isOtpVerified && {
      "& .MuiInput-root": {
        backgroundColor: "#e8f5e8",
        borderColor: "#4caf50",
      },
      "& .MuiInput-root:focus-within": {
        borderColor: "#4caf50",
      },
    }),
  };

  const isPhoneValid = /^\d{10}$/.test(formData.phone);

  const ValidationItem = ({ isValid, text }: { isValid: boolean; text: string }) => (
    <ListItem sx={{ py: 0.5, px: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {isValid ? <CheckIcon sx={{ color: "#4caf50", fontSize: 16 }} /> : <CloseIcon sx={{ color: "#f44336", fontSize: 16 }} />}
        <Typography level="body-sm" sx={{ color: isValid ? "#4caf50" : "#f44336" }}>
          {text}
        </Typography>
      </Box>
    </ListItem>
  );

  return isLoading ? (
    <Loading isLoading={isLoading} />
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 2,
        gap: 2,
        maxWidth: 500,
        margin: "auto",
      }}
      className="register-box"
    >
      <Typography level="h3" textAlign="center" className="heading-2">
        Forgot ?
      </Typography>

      {/* User Type Selection */}
      <FormControl sx={{ width: "100%" }}>
        {/* <FormLabel>User Type</FormLabel> */}
        <RadioGroup orientation="horizontal" value={formData.userType} onChange={handleUserTypeChange} sx={{ gap: 2 }} style={{ justifyContent: "center" }}>
          <Radio value="vendor" label="Password" />
          <Radio value="phone" label="Vendor Code" />
        </RadioGroup>
      </FormControl>

      {formData.userType === "vendor" && (
        <>
          <TextInput
            name="vendorCode"
            label={formData.userType === "vendor" ? "Vendor Code" : "Employee Code"}
            formControlSx={formControlSx}
            value={formData.vendorCode}
            onChange={handleInputChange}
            required
            placeholder={`Enter ${formData.userType === "vendor" ? "Vendor" : "Employee"} Code`}
          />
          <div className="vendor-error">
            {isLoadingVenderChecking && <Typography className="checkingText">Verifying...</Typography>}
            {vendorNotFound && <Typography style={{ color: "red" }}>This vendor id not found.</Typography>}
          </div>

          {!isVerify && formData.vendorCode.length > 0 && (
            <Button color="primary" variant="solid" loading={isVendorDetailsLoading} onClick={handleVerifyVendorId} sx={{ alignSelf: "flex-end" }} className="heading-4">
              Verify
            </Button>
          )}
          {isVerify && (
            <>
              <div style={{ width: "100%" }}>
                <ForgotPasswordDetailsCard vendorList={verifyData} selectedVendor={selectedVendor} setSelectedVendor={setSelectedVendor} />
              </div>
            </>
          )}
        </>
      )}

      <TextInput
        className="phone_number"
        name="phone"
        label="Phone Number"
        formControlSx={formControlSx}
        value={formData.phone}
        onChange={handleInputPhone}
        disabled={formData.userType === "vendor"}
        required
        placeholder="Enter 10-digit Phone Number"
      />
      {isPhoneValid && !isOtpSent && (
        <Button color="primary" loading={sendOtpLoading} variant="solid" onClick={handleSendOtp} sx={{ alignSelf: "flex-end" }} className="heading-4">
          Send OTP
        </Button>
      )}

      {isOtpSent && (
        <>
          <Box sx={{ position: "relative", width: "100%" }}>
            <TextInput
              name="otp"
              label="OTP"
              formControlSx={otpFormControlSx}
              value={formData.otp}
              onChange={handleInputChange}
              required
              placeholder="Enter OTP"
              disabled={isOtpVerified}
            />
            {isOtpVerified && (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 42,
                  transform: "translateY(-50%)",
                  color: "#4caf50",
                  fontSize: 24,
                }}
              />
            )}
          </Box>
          {!isOtpVerified && (
            <Button color="primary" variant="outlined" loading={verifyOtpLoading} onClick={handleVerifyOtp} sx={{ alignSelf: "flex-end" }} disabled={formData?.otp?.length < 6}>
              Verify OTP
            </Button>
          )}
        </>
      )}

      {formData.userType !== "vendor" && isOtpVerified && <ForgotPasswordDetailsCard vendorList={verifyData} selectedVendor={selectedVendor} setSelectedVendor={setSelectedVendor} />}
      {/* Password Field with Eye Button */}
      {formData.userType === "vendor" && (
        <>
          <FormControl sx={formControlSx} required>
            <FormLabel sx={{ fontWeight: "bold" }}>Password</FormLabel>
            <Input
              name="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter Password"
              endDecorator={
                <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ p: 0.5 }}>
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              }
              disabled={!isOtpVerified}
            />
          </FormControl>

          {/* Repeat Password Field with Eye Button */}
          <FormControl sx={formControlSx} required>
            <FormLabel sx={{ fontWeight: "bold" }}>Repeat Password</FormLabel>
            <Input
              name="repeatPassword"
              type={showRepeatPassword ? "text" : "password"}
              value={formData.repeatPassword}
              onChange={handleInputChange}
              placeholder="Enter Password Again"
              endDecorator={
                <IconButton onClick={() => setShowRepeatPassword(!showRepeatPassword)} sx={{ p: 0.5 }}>
                  {showRepeatPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              }
              disabled={!isOtpVerified}
            />
          </FormControl>
        </>
      )}

      {showPasswordValidation && (
        <Box sx={{ width: "100%", mt: 1 }}>
          <Typography level="body-sm" sx={{ mb: 1, fontWeight: "medium" }}>
            Password Requirements:
          </Typography>
          <List sx={{ py: 0 }}>
            <ValidationItem isValid={isPasswordMatched} text="Passwords should match" />
            <ValidationItem isValid={passwordValidation.minLength} text="At least 8 characters" />
            <ValidationItem isValid={passwordValidation.hasUppercase} text="At least one uppercase letter" />
            <ValidationItem isValid={passwordValidation.hasLowercase} text="At least one lowercase letter" />
            <ValidationItem isValid={passwordValidation.hasNumber} text="At least one number" />
            <ValidationItem isValid={passwordValidation.hasSpecialChar} text="At least one special character (!@#$%^&*)" />
          </List>
        </Box>
      )}

      {formData.userType === "vendor" && (
        <Button
          className="heading-4"
          color="success"
          variant="solid"
          sx={{ mt: 2, width: "100%" }}
          onClick={handleForgotPasswordClick}
          disabled={!isPasswordValid || !isPasswordMatched}
        >
          Reset Password
        </Button>
      )}
    </Box>
  );
};

export default ForgotPasswordPage;
